import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { api } from '@/lib/api';

export function DisconnectButton({
  accountId,
  personaId,
}: {
  accountId: string;
  personaId: string;
}) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const m = useMutation({
    mutationFn: () => api.disconnectAccount(accountId),
    onSuccess: () => {
      toast.success('Disconnected. Hit Reconnect any time to log back in.');
      setOpen(false);
      void queryClient.invalidateQueries({ queryKey: ['persona', personaId, 'accounts'] });
    },
    onError: (err) => toast.error('Disconnect failed', { description: String(err) }),
  });

  return (
    <>
      <Button size="sm" variant="ghost" onClick={() => setOpen(true)} disabled={m.isPending}>
        Disconnect
      </Button>
      {open && (
        <ConfirmDialog
          title="Disconnect this account?"
          description="It stops being used for posting, but the saved credentials are kept — so you can Reconnect with one click. No password re-entry needed."
          confirmLabel="Disconnect"
          pending={m.isPending}
          onConfirm={() => m.mutate()}
          onCancel={() => setOpen(false)}
        />
      )}
    </>
  );
}
